/**
 * Created by chenjia on 2017/4/18.
 */
const webviewOpt = {
    init: function (opt) {
        //只有在jdapp中才继续
        if(!this.isApp()) {
            return false;
        }
        let param = {
            "imageLink": ""
        };
        let settings = $.extend(param, opt);

        this.addTitleImg(settings.imageLink);
    },
    getOs: function () {
        let device = '';
        let ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf('iphone') !== -1) {
            device = 'iphone';
        } else if (ua.indexOf('android') !== -1) {
            device = 'android';
        } else if (ua.indexOf('ipad') !== -1) {
            device = 'ipad';
        }
        return device;
    },
    isApp: function() {
        let u = navigator.userAgent.toLowerCase();
        return u.indexOf("jdapp") > -1;
    },
    addTitleImg: function (imageLink) {
        let os = this.getOs();
        var url = location.origin + location.pathname;
        var jdapp = {};
        var param = [];
        param[0] = "京选全球 从全球为你京挑细选";
        param[1] = "诚心推荐来自全世界的美好，不用费心挑选。品质保证，华东部分211送达，尽在京选全球。";
        param[2] = location.href;
        param[3] = "https://img14.360buyimg.com/cms/jfs/t8101/189/1983194185/8706/5a58e772/59c21bc2N5d890039.jpg?t=1506661022036";
        if (os === 'iphone') {
            location.href = "openapp.jdmobile://communication?params={\"action\":\"syncShareData\",\"title\":\"" + param[0] + "\",\"content\":\"" + param[1] + "\",\"shareUrl\":\"" + encodeURIComponent(param[2]) + "\",\"iconUrl\":\"" + encodeURIComponent(param[3]) + "\",\"incentiveBizType\":\"\",\"incentiveBizId\":\"\",\"isCallBack\":\"N\"}";
            setTimeout(function(){
              location.href = 'openapp.jdmobile://communication?params={' + '"action":"sh_showImgTitle",' + '"imageUrl":"' + imageLink + '"' + '}';
            },500);
        } else if (os === 'android') {
            let options = {imageUrl: imageLink};
            options.isShow = "Y";
            setTimeout(function(){
              AndroidNavi && AndroidNavi.setTitle(JSON.stringify(options));
            },500)
            shareHelper.setShareInfo(param[0], param[1], param[2], param[3]);

        }
    }
};

module.exports = webviewOpt;



// WEBPACK FOOTER //
// ./src/js/unit/webviewOpt/webviewOpt.js